import { z } from 'zod';
import { IdSchema } from './encoding.js';
/**
 * A reference to a record of any type (SDD §5.6; ERD §8.9, MD-05). It appears only in the DTOs of
 * the seven record-agnostic capabilities — documents, audit, workflow, notifications, postings,
 * VAT detail and migration items — never in a business-to-business relationship, which is typed.
 */
export const RecordRefSchema = z.object({
    recordType: z
        .string()
        .regex(/^[a-z][a-z0-9_]*\.[a-z][a-z0-9_]*$/, 'must be <module>.<record>')
        .max(100),
    recordId: IdSchema,
});
//# sourceMappingURL=record-ref.js.map